export default __webpack_public_path__ + "static/pro@768-9319c83c1acf6b6fc038e455426f68c5.webp";